import { createContext, useContext } from 'react';
import type { SessionNoteFormRegistry } from '../sessionNote/sessionNoteFormRegistry';
import type { AssistantTargetRegistry } from './assistantTargetRegistry';

export interface AssistantSpotlight {
  elements: HTMLElement[];
  caption: string | null;
}

export interface AssistantUiContextValue {
  registry: AssistantTargetRegistry;
  sessionNoteForms: SessionNoteFormRegistry;
  showSpotlight: (spotlight: AssistantSpotlight) => void;
  clearSpotlight: () => void;
  announce: (message: string) => void;
  hasEditsOnCurrentPage: () => boolean;
}

export interface AssistantUiStateContextValue {
  spotlight: AssistantSpotlight | null;
  announcement: string;
}

export const AssistantUiContext = createContext<AssistantUiContextValue | null>(null);
export const AssistantUiStateContext = createContext<AssistantUiStateContextValue | null>(null);

export function useOptionalAssistantUi(): AssistantUiContextValue | null {
  return useContext(AssistantUiContext);
}

export function useAssistantUi(): AssistantUiContextValue {
  const context = useContext(AssistantUiContext);
  if (context === null) {
    throw new Error('useAssistantUi must be used inside AssistantUiProvider');
  }
  return context;
}

export function useAssistantUiState(): AssistantUiStateContextValue {
  const context = useContext(AssistantUiStateContext);
  if (context === null) {
    throw new Error('useAssistantUiState must be used inside AssistantUiProvider');
  }
  return context;
}
